import React, { useCallback } from 'react';
import useSWR from 'swr';

const fetcher = url => fetch(url).then(r => r.json());

export default function Banners() {
  const { data: banners } = useSWR('/api/faq/banners/', fetcher);

  const formatDate = useCallback(dateString => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }, []);

  return (
    <div className="my-8 space-y-4">
      {banners?.data?.map(({ id, attributes }) => {
        const { title, text, updated_at } = attributes;

        return (
          <div
            key={id}
            className="max-w-screen-sm space-y-4 rounded-lg border border-solid border-gray bg-white p-4"
          >
            <div className="flex items-center justify-between">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="h-6 w-6 shrink-0"
              >
                <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z" />
              </svg>
              <span className="font-bold text-dark-gray">
                {formatDate(updated_at)}
              </span>
            </div>
            <span className="block font-bold">{title}</span>
            <span className="block text-sm">{text}</span>
          </div>
        );
      })}
    </div>
  );
}
